<h1>Home Services - Campaign Manager - {{selectedEnv}}</h1>
<div class="row box">
  <div class="col-md-9"></div>
  <div class="col-md-3">Welcome,{{loggedInUser.userDetails.displayName}} <a href="#" (click)="logout()">[Logout]</a></div>
  
</div>